import React, { useMemo } from 'react';

interface OutlinedButtonProps {
  testId?: string;
  text: string;
  onClick?: () => void;
  isClicked: boolean;
  className?: string;
}

export const OutlinedButton: React.FC<OutlinedButtonProps> = ({
  text,
  testId,
  onClick = () => {},
  isClicked,
  className,
}) => {
  const isClickedClass = useMemo(
    () => (isClicked ? 'bg-light-3' : 'bg-white hover:bg-light-2'),
    [isClicked]
  );

  const handleOnClick = () => {
    onClick();
  };

  return (
    <div
      className={`${isClickedClass} noto-13-medium cursor-pointer rounded-[5px] border border-dark-6 text-dark-4 ${className}`}
      data-testid={testId}
      onClick={handleOnClick}
    >
      <p className="mx-5 my-[7px] w-[110px] text-center leading-[23px]">
        {text}
      </p>
    </div>
  );
};
